import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { dataDefault } from 'Components/User/Collectors/CollectionPoint'
import { apiCollectorsList, apiCollectorsView } from 'Services/AdminService'

export const getData = createAsyncThunk('admin/collectors/getData', async datas => {
    const { data } = await apiCollectorsList(datas)
    return data
})

export const getView = createAsyncThunk('admin/collectors/getView', async id => {
    if (!id) return viewData
    const { data } = await apiCollectorsView(id)
    data.phone = data.phone ?? ''
    data.image = ''
    data.collection_point = data.collection_point && data.collection_point.length !== 0 ? data.collection_point : [dataDefault]
    return data
})

const viewData = {
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    password: '',
    password_confirmation: '',
    image: '',
    collection_point: [dataDefault],
}

export const collectorsSlice = createSlice({
    name: 'admin/collectors',
    initialState: {
        loading: true,
        view: viewData,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData } = collectorsSlice.actions

export default collectorsSlice.reducer
